import { render, staticRenderFns } from "./SendEmailForm.vue?vue&type=template&id=9ad04c16&"
import script from "./SendEmailForm.vue?vue&type=script&lang=js&"
export * from "./SendEmailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports